import {useUsers} from "@hooks";
import {Typography} from "@mui/material";
import {TypographyVariant} from "@mui/material/styles/createTypography";

const UserFullname = ({
  userId,
  variant,
  flat,
}: {
  userId: string | undefined;
  variant?: TypographyVariant;
  flat?: boolean;
}) => {
  const {getUserFullname} = useUsers();
  if (flat) {
    return <>{getUserFullname(userId)}</>;
  }
  return <Typography variant={variant}>{getUserFullname(userId)}</Typography>;
};

export {UserFullname};
